
export function saveStorageObject<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
}

export function getStorageObject<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key || "") || "{}") as T;
}
export function removeStorage(key: string): any {
    localStorage.removeItem(key);
}
